import { ReportDetails } from "@idwal/idwal-react-components";
import { useMemo } from "react";
import { LoadingParticulars } from "../loading/LoadingParticulars";
import { useParams } from "react-router-dom";
import { showRequestErrorToast } from "../../services/ErrorService";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { getVesselInspectionData } from "../../queries/particularsQueries";
import dayjs from "dayjs";
import { getInspectedGradeQuery } from "../../queries/gradingQueries";

export const VesselParticulars = () => {
    const { inspectionId } = useParams();
    const { user } = useAuthenticator((context) => [
        context.authStatus,
        context.user
    ]);

    const { data, isError, isLoading, error } = getVesselInspectionData(
        inspectionId ?? "",
        user
    );

    const { data: inspectedGrade } = getInspectedGradeQuery(inspectionId ?? "", data?.IMONumber ?? "", data?.isInspectionCopy ?? false);

    const formatDate = (date: string | undefined) =>
        date ? dayjs(date).format("DD MMMM YYYY") : "";

    const getDate = (dateFromString: string, dateToString: string) => {
        if (!dateToString) {
            return formatDate(dateFromString);
        }

        return `${formatDate(dateFromString)} - ${formatDate(dateToString)}`;
    };

    const reportDetails = useMemo(
        () =>
            data
                ? {
                      Grade: 0,
                      GradeImageUrl: inspectedGrade?.imageUrl ?? "",
                      ShipName: data.shipName,
                      InspectionType: data.InspectionType,
                      Details: [
                          {
                              key: "imoNumber",
                              value: data.IMONumber,
                              selector: "imo"
                          },
                          {
                              key: "inspectionType",
                              value: data.InspectionType,
                              selector: "inspection-type"
                          },
                          {
                              key: "inspectionRef",
                              value: data.InspectionNumber,
                              selector: "inspection-number"
                          },
                          {
                              key: "inspectionIssuedAt",
                              value: formatDate(data.InspectionIssuedAt),
                              selector: "issued-at"
                          },
                          {
                              key: "inspectedAt",
                              value: data.InspectedAt,
                              selector: "inspected-at"
                          },
                          {
                              key: "date",
                              value: getDate(
                                  data.InspectedDateFrom,
                                  data.InspectedDateTo
                              ),
                              selector: "inspected-date"
                          },
                          {
                              key: "technicalManager",
                              value: data.TechnicalManager,
                              selector: "manager"
                          },
                          {
                              key: "registeredOwner",
                              value: data.RegisteredOwner,
                              selector: "registered-owner"
                          }
                      ]
                  }
                : undefined,
        [data, inspectedGrade]
    );

    if (isLoading) {
        return <LoadingParticulars />;
    }

    if (isError) {
        console.error(error);
        showRequestErrorToast("toasts.vesselParticularsNotLoaded");
        return <></>;
    }

    if (reportDetails) {
        return isLoading ? (
            <LoadingParticulars />
        ) : (
            <ReportDetails reportDetails={reportDetails} />
        );
    }

    return <LoadingParticulars />;
};
